import projectConfig from "@projectConfig";
import { store } from "../../../../appRedux/store/Store";

export const getLabelFromTechName = (techName, columns) => {
   return columns.find((column) => column.options?.techName === techName)?.label || null;
};

export const getTechNameFromLabel = (label, columns) => {
   return columns.find((column) => column.label === label)?.options?.techName || null;
};

export const createAnswer = (question, params) => {
   return {
      questionnaire_Id: question.questionnaireId,
      question_id: question.questionId,
      question_type: question?.type,
      question_content: question.content,
      answer: "",
      surveyed_user_id: store.getState()?.user?.oldId || 0,
      compared_user_id: 0,
      received_points: 0,
      max_points: question.maxPoints ?? "",
      question_description: question.description ?? "",
      ...params
   };
};

export const createOptions = (optionsAsString) => {
   //We have to transform string to array
   // I'm using regex in replace, because traditional usage does not work every time

   if (optionsAsString?.includes('",'))
      return optionsAsString.split('",').map((option) => option.replace(/"/g, ""));
   //Case when there is only one answer, there has to be != ( not !== )
   else return optionsAsString != "" ? [optionsAsString?.replace(/"/g, "")] : [];
};

export const createContent = (data) => {
   let content = [];

   //firstly We have to sort by questions by order or shuffle them
   const questions = projectConfig.questionnaireTable.randomOrder
      ? data.data.sort(() => Math.random() - 0.5)
      : data.data.sort(
           (a, b) =>
              a[getLabelFromTechName("question_order", data.columns)] -
              b[getLabelFromTechName("question_order", data.columns)]
        );

   //some questionnaires doesnt not have secion at the start, so we need to create one
   if (questions[0][getLabelFromTechName("question_type", data.columns)].value !== "section") {
      content.push({
         type: "section",
         questionId: 0,
         fields: [],
         content: "",
         order: 1
      });
   }

   questions.map((question) => {
      if (question[getLabelFromTechName("question_type", data.columns)].value === "section") {
         //creating new section
         content.push({
            type: question[getLabelFromTechName("question_type", data.columns)].value,
            questionId: +question[getLabelFromTechName("question_id", data.columns)],
            fields: [],
            content: question[getLabelFromTechName("question_content", data.columns)],
            order: question[getLabelFromTechName("question_order", data.columns)]
         });
      } else {
         //adding question to last created section
         content[content.length - 1].fields.push({
            type: question[getLabelFromTechName("question_type", data.columns)].value,
            questionId: +question[getLabelFromTechName("question_id", data.columns)],
            questionnaireId: +question[getLabelFromTechName("questionnaire_id", data.columns)],
            options: createOptions(
               question[getLabelFromTechName("available_options", data.columns)]
            ),
            content: question[getLabelFromTechName("question_content", data.columns)],
            hint: question[getLabelFromTechName("question_hint", data.columns)],
            additionalAnswer:
               question[getLabelFromTechName("additional_answer_field", data.columns)],
            maxPoints: question[getLabelFromTechName("max_points", data.columns)],
            description: question[getLabelFromTechName("question_description", data.columns)],
            order: question[getLabelFromTechName("question_order", data.columns)],
            correctAnswer: question[getLabelFromTechName("correct_answer", data.columns)],
            requiredAnswers: +question[getLabelFromTechName("required_answers", data.columns)]
         });
      }
   });

   // Uncomment to test putInorder
   // content[0].fields.push({
   //    type: "putInOrder",
   //    questionId: 12436757,
   //    options: ["MR", "TO PRODUCTION", "TO TEST", "IN PROGRESS", "DONE"],
   //    content: "Ułóż w kolejności proces tworzenia taska:",
   //    hint: null,
   //    additionalAnswer: null,
   //    maxPoints: null,
   //    description: null,
   //    order: 123
   // });

   //Uncomment to test MultiChooseFrom
   // content[0].fields.push({
   //    type: "multiChooseFrom",
   //    questionId: 12436757,
   //    options: ["Smutek", "Szczerość", "Zachwyt", "Wzruszenie", "Radość", "Gniew"],
   //    content: "Wybierz 3 emocje, jaki Ci dzisiaj towarzyszyły:",
   //    hint: null,
   //    additionalAnswer: null,
   //    maxPoints: null,
   //    description: null,
   //    order: -1,
   //    requiredAnswers: 4
   // });

   return content;
};
